module.exports = __webpack_public_path__ + "static/media/pay_redeem.9c705f1c.svg";